<div class="formBox" fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="center center" class="formContainer">

        <h6 class="h6Title">Recuperar contraseña</h6>
        <p class="text-center">Ingrese su dirección de correo electrónico para solicitar un restablecimiento de contraseña.</p>
        <br>
  
        <div fxLayout="column" class="fw mgb10">
          <label for="">Correo electrónico</label>
          <input type="email" class="fw" #passwordResetEmail required>
        </div>
  
        <div class="fw mgb20">
          <button class="darkButton fw" (click)="authService.ForgotPassword(passwordResetEmail.value)">
            Reestablecer contraseña
          </button>
        </div>
  
      <div class="containerFullWidthCentered">
        <a class="blackLink" routerLink="/login-empresas" >Regresar a inicio de sesión</a>
      </div>
      
    </div>
  </div>
